import React from 'react';
import Button, { ButtonProps } from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Row from 'react-bootstrap/Row';
import { ImageModel, LinkModel } from '../../models/globals';
import { BackgroundPicture } from '../html5/BackgroundPicture';

interface BaseProps {
    content: string[];
    defaultImage: ImageModel;
    header: string;
    image: ImageModel;
    keyPoints: null;
    link: LinkModel;
    videoUrl: null;
    subHeader?: string;
}

interface PageSectionStackedProps {
    propsToRender: BaseProps[];
    className?: string;
    contentClassName?: string;
    headerClassName?: string;
    subHeaderClassName?: string;
    buttonPropOverrides?: ButtonProps;
    isRelated?: boolean;
}

const PageSectionStacked: React.FC<PageSectionStackedProps> = ({
    propsToRender,
    className = 'page-section-stacked',
    contentClassName = 'font-weight-light text-justify text-black mb-4',
    headerClassName = 'font-weight-light mb-4',
    subHeaderClassName = 'font-weight-light',
    buttonPropOverrides,
    isRelated = false,
}) => {
    return (
        <Jumbotron className={`${className} d-flex mb-0 px-2 px-md-3`.trim()}>
            <Container
                className={`${
                    isRelated ? 'mycaa-page-container px-5 flex-column align-items-center' : ''
                } clearfix d-flex justify-content-center`.trim()}
                fluid
            >
                {isRelated && (
                    <h2 className="mycaa-page-title text-black font-weight-light align-self-start mb-4">
                        Related Articles
                    </h2>
                )}
                <Row className="d-flex flex-wrap page-section-inner w-100">
                    {propsToRender.map((child, index) => {
                        return (
                            <Col
                                className={`d-flex flex-column ${isRelated ? 'pl-0 mb-4' : ''}`.trim()}
                                xs={12}
                                md={12 / propsToRender.length}
                                key={index}
                            >
                                <BackgroundPicture
                                    className={`${
                                        isRelated ? 'mycaa-page-mobile-image' : ''
                                    } page-section-stacked-image-wrapper mb-4`.trim()}
                                    {...child.image}
                                    defaultImage={child.defaultImage}
                                />
                                <h2 className={`${headerClassName}`}>{child.header}</h2>
                                {child.subHeader && <h3 className={`${subHeaderClassName}`}>{child.subHeader}</h3>}
                                <section className={`page-section-stacked-content ${contentClassName}`}>
                                    {child.content.map((paragraph) => {
                                        return (
                                            <p
                                                className={contentClassName}
                                                key={paragraph}
                                                dangerouslySetInnerHTML={{
                                                    __html: paragraph,
                                                }}
                                            />
                                        );
                                    })}
                                    <Button
                                        className="font-weight-bold px-4 text-capitalize"
                                        data-testid={child.link.url}
                                        href={child.link.url}
                                        size="lg"
                                        variant="primary"
                                        {...buttonPropOverrides}
                                    >
                                        <span className="sr-only">{`Read more about ${child.header}`}</span>
                                        {child.link.name}
                                    </Button>
                                </section>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        </Jumbotron>
    );
};

export { PageSectionStacked, BaseProps, PageSectionStackedProps };
